import { useSite } from "@/context/SiteContext";
import { CommunityPromo } from "@/components/Promos";
import { GrowthListBlock } from "@/components/EmailCapture";

export default function Community() {
  const { settings } = useSite();
  return (
    <div className="container-bt space-y-16 py-14 sm:py-20" data-testid="community-page">
      <div className="max-w-3xl">
        <p className="eyebrow mb-4">Community</p>
        <h1 className="text-4xl leading-tight sm:text-5xl lg:text-6xl">{settings.brand.tagline}</h1>
      </div>
      <CommunityPromo />
      <GrowthListBlock source="community" />
    </div>
  );
}
